import { SectionHeading } from "../components/SectionHeading";
import { Reveal } from "../components/Reveal";

const STEPS = [
    {
        number: "01",
        title: "Enquire",
        description: "Tell us what products or categories you are looking for.",
    },
    {
        number: "02",
        title: "Discuss",
        description: "We review your requirements and discuss suitable options.",
    },
    {
        number: "03",
        title: "Supply",
        description: "We work towards fulfilling your product requirements.",
    },
];

export const Process = () => (
    <section data-testid="how-we-work-section" className="border-t border-slate-100 bg-slate-50">
        <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-24">
            <SectionHeading eyebrow="Our Process" title="How We Work" />
            <div className="mt-14 grid gap-10 sm:grid-cols-3 sm:gap-6 lg:gap-10">
                {STEPS.map((step, i) => (
                    <Reveal key={step.number} delay={i * 140}>
                        <div
                            data-testid={`process-step-${i + 1}`}
                            className="relative border-t-2 border-navy-900 pt-8"
                        >
                            <span className="font-heading text-5xl font-extrabold tracking-tight text-gold">
                                {step.number}
                            </span>
                            <h3 className="mt-4 font-heading text-xl font-semibold text-navy-900">
                                {step.title}
                            </h3>
                            <p className="mt-3 max-w-xs text-sm leading-relaxed text-slate-600">
                                {step.description}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
